module.exports = __webpack_public_path__ + "static/media/logohorizontal.65e91eaa.svg";